import { http } from '@/services';

export default {
  login: ({ email, senha }) => {
      return http.post('auth', { email, senha });
  },

  getCurrentUser: async function(idUsuario) {
    try {
      if (idUsuario === undefined)
        return Promise.reject(
          new Error('Missing required  parameter: idUsuario'),
        );
      return await http.get(`usuario/${idUsuario}`);
    } catch (e) {
      console.error(e);
      return e.response.data || e;
    }
  },
};
